import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Sparkles, Heart, Leaf, Award } from "lucide-react";

const trustPoints = [
  {
    icon: Sparkles,
    text: "Crafted with Intention",
  },
  {
    icon: Leaf,
    text: "Inspired by Nature",
  },
  {
    icon: Heart,
    text: "Made for Healthy Hair Routines",
  },
  {
    icon: Award,
    text: "Premium Scalp & Moisture Care",
  },
];

const SocialProofSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      ref={ref}
      className="py-24 md:py-32 bg-brand-cream relative overflow-hidden"
      data-testid="social-proof-section"
    >
      {/* Decorative Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-softBeige/50 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-brand-warmGold text-xs tracking-[0.3em] uppercase font-body block mb-4"
          >
            The Promise
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-heading text-4xl sm:text-5xl font-light text-brand-deepGreen mb-4"
          >
            Why Choose Us
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scaleX: 0 }}
            animate={isInView ? { opacity: 1, scaleX: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="section-divider mx-auto"
          />
        </div>

        {/* Trust Points */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustPoints.map((point, index) => (
            <motion.div
              key={point.text}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 * index }}
              className="text-center group"
              data-testid={`trust-point-${index}`}
            >
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-softBeige mb-6 group-hover:bg-brand-deepGreen/5 transition-colors duration-500 border border-brand-deepGreen/10">
                <point.icon
                  className="w-8 h-8 text-brand-warmGold"
                  strokeWidth={1}
                />
              </div>
              <p className="text-brand-deepGreen font-heading text-lg font-light">
                {point.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
